import React from 'react';
import { useSelector } from 'react-redux';
import { standortUrlSelector } from '../../../modules/selectors/url';
import CardSlider from '../layout/CardSlider';
import { apiClient, useAsyncFunction } from '../../../helpers/apiHelperV2';
import ReduxSuspense from '../ReduxSuspense/ReduxSuspense';
import InlineSpinner from '../Spinner/InlineSpinner';
import ProductCard from '../layout/ProductCard';

function MoreProducts() {
    const standortUrl = useSelector(standortUrlSelector);

    const moreProductsResponse = useAsyncFunction(async () => await apiClient.get(`/api/v1/MoreProducts?standortUrl=${standortUrl}`), [
        standortUrl,
    ]);

    return (
        <ReduxSuspense response={moreProductsResponse} error={null} fallback={<InlineSpinner />}>
            {data => {
                if (!data?.data) return null;
                return (
                    <section className="uk-section uk-section-default uk-section-small">
                        <div className="uk-container">
                            <h2 className="uk-text-light" style={{ fontSize: '1.75rem'}}>Das könnte Sie interessieren</h2>
                            <h3>Wird auch oft von Kunden gekauft</h3>
                            <CardSlider>
                                {data.data.map(product => (
                                    <li key={product.id}>
                                        <ProductCard product={product} />
                                    </li>
                                ))}
                            </CardSlider>
                        </div>
                    </section>
                );
            }}
        </ReduxSuspense>
    );
}

export default MoreProducts;
